module.exports = __webpack_public_path__ + "img/Corsica.141764f2.svg";